import Vue from 'vue'
import Router from 'vue-router'
import Homemain from '@/components/homemain'
// import Homemain from '@/components/homemain2'
import Product from '@/components/product'
import Service from '@/components/service'
import Teamwork from '@/components/teamwork'
import Information from '@/components/information'
import InformationDetail from '@/components/informationDetail'
import About from '@/components/about'

import CustomerService from '@/components/product/customerService'//产品-智能客服
import Marketing from '@/components/product/marketing'//产品-智能营销
import IVR from '@/components/product/IVR'//产品-智能IVR
import SpeechAnalysis from '@/components/product/speechAnalysis'//产品-智能语音分析
import SeatAssistant from '@/components/product/seatAssistant'//产品-智能坐席助手
import EnterPrise from '@/components/product/enterPrise'//产品-企业客服系统
import BigData from '@/components/product/bigData'//产品-大数据中台
import ProHotline from '@/components/product/proHotline'//产品-心理援助热线系统

import News from '@/components/news/index'//新闻资讯
import NewsDetail from '@/components/news/detail'//新闻资讯-详情

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      name: '首页',
      component: Homemain,
    },
    {
      path: '/product/customerService',
      name: '产品-智能客服',
      component: CustomerService,
    },
    {
      path: '/product/marketing',
      name: '产品-智能营销',
      component: Marketing,
    },
    {
      path: '/product/IVR',
      name: '产品-智能IVR',
      component: IVR,
    },
    {
      path: '/product/speechAnalysis',
      name: '产品-智能语音分析',
      component: SpeechAnalysis,
    },
    {
      path: '/product/seatAssistant',
      name: '产品-智能坐席助手',
      component: SeatAssistant,
    },
    {
      path: '/product/enterPrise',
      name: '产品-企业客服系统',
      component: EnterPrise,
    },
    {
      path: '/product/bigData',
      name: '产品-大数据中台',
      component: BigData,
    },
    {
      path: '/product/proHotline',
      name: '产品-心理援助热线系统',
      component: ProHotline,
    },
    {
      path: '/news',
      name: '新闻资讯',
      component: News,
    },
    {
      path: '/newsDetail/:mId(\\d+)',
      name: '新闻资讯-详情',
      component: NewsDetail
    },


    {
      path: '/service',
      name: '服务页',
      component: Service,
    },
    {
      path: '/product',
      name: '产品',
      component: Product,
    },
    {
      path: '/teamwork',
      name: '渠道合作',
      component: Teamwork,
    },
    {
      path: '/information',
      name: '资讯',
      component: Information,
    },
    {
      path: '/informationDetail',
      name: '详情页',
      component: InformationDetail,
    },
    {
      path: '/about',
      name: '关于我们',
      component: About,
    },
    {
      path: '*',
      redirect:"/index"
    }

   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js